import { Reducer } from "redux";
import {
  AuthAction,
  AuthActionType,
  ICallbackCreateCustomerAction,
  ICallbackGetMeAction,
  IObserveAuthListenerAction,
} from "../action/auth_action";
import { AuthStateType } from "../auth_state_type";
import { AuthState } from "../store/auth_state";

const initialState: AuthState = {
  user: null,
  company: null,
  authState: AuthStateType.INITIALIZING,
  isLoading: false,
};

const authReducer: Reducer<AuthState> = (
  state = initialState,
  action: AuthAction
): AuthState => {
  switch (action.type) {
    case AuthActionType.OBSERVE_AUTH_LISTENER: {
      const _action = action as IObserveAuthListenerAction;
      if (action.isSuccess) {
        return Object.assign({}, state, {
          user: _action.item ? _action.item.user : null,
          company: state.company,
          authState: _action.item
            ? _action.item.authState
            : AuthStateType.INITIALIZING,
          isLoading: state.isLoading,
        });
      } else {
        return Object.assign({}, state, {
          user: state.user,
          company: state.company,
          authState: state.authState,
          isLoading: state.isLoading,
        });
      }
    }

    case AuthActionType.REQUEST_ON_AUTH_LISTENER: {
      return Object.assign({}, state, {
        user: state.user,
        company: state.company,
        authState: state.authState,
        isLoading: true,
      });
    }
    case AuthActionType.CALLBACK_ON_AUTH_LISTENER: {
      if (action.isSuccess) {
        return Object.assign({}, state, {
          user: state.user,
          company: state.company,
          authState: state.authState,
          isLoading: false,
        });
      } else {
        return Object.assign({}, state, {
          user: state.user,
          company: state.company,
          authState: state.authState,
          isLoading: false,
        });
      }
    }

    case AuthActionType.REQUEST_OFF_AUTH_LISTENER: {
      return Object.assign({}, state, {
        user: state.user,
        company: state.company,
        authState: state.authState,
        isLoading: true,
      });
    }
    case AuthActionType.CALLBACK_OFF_AUTH_LISTENER: {
      if (action.isSuccess) {
        return Object.assign({}, state, {
          user: state.user,
          company: state.company,
          authState: state.authState,
          isLoading: false,
        });
      } else {
        return Object.assign({}, state, {
          user: state.user,
          company: state.company,
          authState: state.authState,
          isLoading: false,
        });
      }
    }

    case AuthActionType.REQUEST_LOGIN: {
      return Object.assign({}, state, {
        user: state.user,
        company: null,
        authState: state.authState,
        isLoading: true,
      });
    }
    case AuthActionType.CALLBACK_LOGIN: {
      if (action.isSuccess) {
        return Object.assign({}, state, {
          user: state.user,
          company: null,
          authState: state.authState,
          isLoading: false,
        });
      } else {
        return Object.assign({}, state, {
          user: state.user,
          company: null,
          authState: state.authState,
          isLoading: false,
        });
      }
    }

    case AuthActionType.REQUEST_LOGOUT: {
      return Object.assign({}, state, {
        user: state.user,
        company: null,
        authState: state.authState,
        isLoading: true,
      });
    }
    case AuthActionType.CALLBACK_LOGOUT: {
      if (action.isSuccess) {
        return Object.assign({}, state, {
          user: state.user,
          company: null,
          authState: state.authState,
          isLoading: false,
        });
      } else {
        return Object.assign({}, state, {
          user: state.user,
          company: null,
          authState: state.authState,
          isLoading: false,
        });
      }
    }

    case AuthActionType.REQUEST_PASSWORD_RESET: {
      return Object.assign({}, state, {
        user: state.user,
        company: state.company,
        authState: state.authState,
        isLoading: true,
      });
    }
    case AuthActionType.CALLBACK_PASSWORD_RESET: {
      if (action.isSuccess) {
        return Object.assign({}, state, {
          user: state.user,
          company: state.company,
          authState: state.authState,
          isLoading: false,
        });
      } else {
        return Object.assign({}, state, {
          user: state.user,
          company: state.company,
          authState: state.authState,
          isLoading: false,
        });
      }
    }

    case AuthActionType.REQUEST_CREATE_CUSTOMER: {
      return Object.assign({}, state, {
        user: state.user,
        company: state.company,
        authState: state.authState,
        isLoading: true,
      });
    }
    case AuthActionType.CALLBACK_CREATE_CUSTOMER: {
      const _action = action as ICallbackCreateCustomerAction;
      if (action.isSuccess) {
        return Object.assign({}, state, {
          user: _action.item ? _action.item.user : null,
          company: state.company,
          authState: AuthStateType.LOGIN_USER,
          isLoading: false,
        });
      } else {
        return Object.assign({}, state, {
          user: state.user,
          company: state.company,
          authState: state.authState,
          isLoading: false,
        });
      }
    }

    // 現状Clientの登録はセルフサービスでなくLibera社員にて対応するため、CallbackのItem設定を行っていない
    case AuthActionType.REQUEST_APPLY_CLIENT: {
      return Object.assign({}, state, {
        user: state.user,
        company: state.company,
        authState: state.authState,
        isLoading: true,
      });
    }
    case AuthActionType.CALLBACK_APPLY_CLIENT: {
      if (action.isSuccess) {
        return Object.assign({}, state, {
          user: null,
          company: null,
          authState: AuthStateType.UNKNOWN,
          isLoading: false,
        });
      } else {
        return Object.assign({}, state, {
          user: state.user,
          company: state.company,
          authState: state.authState,
          isLoading: false,
        });
      }
    }

    case AuthActionType.REQUEST_GET_ME: {
      return Object.assign({}, state, {
        user: state.user,
        company: state.company,
        authState: state.authState,
        isLoading: true,
      });
    }
    case AuthActionType.CALLBACK_GET_ME: {
      const _action = action as ICallbackGetMeAction;
      if (action.isSuccess) {
        return Object.assign({}, state, {
          user: _action.item ? _action.item.user : null,
          company: _action.item ? _action.item.company : null,
          authState: AuthStateType.LOGIN_USER,
          isLoading: false,
        });
      } else {
        return Object.assign({}, state, {
          user: state.user,
          company: state.company,
          authState: AuthStateType.UNKNOWN,
          isLoading: false,
        });
      }
    }

    default:
      return state;
  }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/auth_reducer.ts